import React, {memo, useEffect, useState} from 'react';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import Button from 'antd/es/button';
import Radio from 'antd/es/radio';
import Typography from 'antd/es/typography';
import './MedPassCard.css';
import {convertDaysToMonths} from '../../../../helpers/util';

const {Paragraph} = Typography;

const colors = [
  '#1d3557',
  '#64126B',
  '#e76f51',
  '#39A7A6',
  '#3C145F',
  '#2EA35D',
  '#4773CF',
  '#DD615F',
  '#64126B',
  '#00afb9',
];

const MedPassCard = memo(({data, passesCount, passIndex, onBuy, mini}) => {
  const [activePassIndex, setActivePassIndex] = useState(passesCount - 1);

  useEffect(() => {
    console.log(data);
  }, [])

  const {id, description, subscriptionModel, subscriptionType, price, offerPrice} = data[activePassIndex];
  const currColor = colors[passIndex % colors.length];
  const offerPercentage = Math.round((price - offerPrice) / price * 100);

  const getTitle = () => {
    if (subscriptionModel === 1) {
      return 'Combo Pass';
    } else if (subscriptionModel === 2) {
      return 'Video Pass';
    } else if (subscriptionModel === 3) {
      return 'Test Pass';
    }
  };

  const buildValidityOptions = () => data.map(({numberOfSubs}, index) => {
    return (
        <Col span={12} key={numberOfSubs}>
          <Radio
              value={index}
              className="mc-white-text mc-mt-5"
          >{convertDaysToMonths(numberOfSubs)}</Radio>
        </Col>
    );
  });

  const handleValidityChange = e => {
    setActivePassIndex(e.target.value);
  };

  const buyMedPass = () => {
    onBuy(id, subscriptionType, offerPrice);
  };

  const buildClassNames = mini ? 'medpass-card fluid-card' : 'medpass-card';

  return (
      <div className={buildClassNames} style={{backgroundColor: currColor}}>
        <div className="mpc-offer-block">
          <p className="mpc-offer-percentage"><b>{offerPercentage}%</b><br/>OFF
          </p>
        </div>
        <Row>
          <Col span={24}>
            <p className="mpc-title">{getTitle()}</p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p className="mpc-offer-price">₹{offerPrice}</p>
            <p className="mpc-price">₹{price}</p>
            {
              !mini && (
                  <>
                    <hr/>
                    <Paragraph
                        ellipsis={{rows: 4, expandable: true}}
                        className="mpc-description"
                    >
                      {description}
                    </Paragraph>
                  </>
              )
            }
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <h3 className="mc-white-text">Validity</h3>
          </Col>
          <Col span={24}>
            <Radio.Group
                value={activePassIndex}
                onChange={handleValidityChange}
            >
              <Row>
                {buildValidityOptions()}
              </Row>
            </Radio.Group>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Button
                block
                size="large"
                className="mpc-btn mc-mt-10"
                onClick={buyMedPass}
            >Buy medPass</Button>
          </Col>
        </Row>
      </div>
  );
});

export {MedPassCard};
